import React from "react";
import { connect } from "react-redux";

import { toSelectableCropDropdownOptions, useCropList } from "~/admin/setup/customer/use-crop-list";
import { useLoggedInUserProductScopeOrgLevelGuid } from "~/admin/setup/customer/use-product-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { dropdowns, pickLists, unitTypes, service, model } from "./../data";
import { fetchDropdownData } from "~/core/dropdowns/actions";
import { getDropdown } from "~/admin/selectors";

const mapStateToProps = (state) => ({
    [model.PROPS_GROWTH_STAGE_ORDER]: getDropdown(model.PROPS_GROWTH_STAGE_ORDER, state),
});

const mapDispatchToProps = () => ({
    fetchGrowthStage: (v) => fetchDropdownData(v),
});

const ConnectedAddEditPanel = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    AddEditPanelContainer(AddEditPanel, {
        dropdowns,
        pickLists,
        unitTypes,
        service,
    })
);

const AddEditContainer = (props) => {
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{ [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops) }}
        />
    );
};

export default AddEditContainer;
